import React, { useMemo } from 'react';
import { Formik } from 'formik';
import classNames from 'classnames';
import { Button, Checkbox } from '@cian/ui-kit';

import { EBlockType, IComplaint } from '../../api/complaints';
import * as styles from './ComplaintItem.css';

interface IComplaintItemProps {
  complaint: IComplaint;
  index: number;
  selected: number | null;
  onClick(index: number, complaint: IComplaint): void;
  onSubmit(complaint: IComplaint, message?: string): Promise<void>;
}

export function ComplaintItem({ complaint, index, onClick, onSubmit, selected }: IComplaintItemProps) {
  const handleChange = React.useCallback(() => {
    onClick(index, complaint);
  }, [index, complaint]);

  const isSelected = useMemo(() => index === selected, [index, selected]);

  return (
    <div className={styles['cont']}>
      <Checkbox label={complaint.name} checked={isSelected} onChange={handleChange} />
      {isSelected && complaint.blockType === EBlockType.Textarea && (
        <Formik
          initialValues={{ message: '' }}
          validate={values => {
            if (complaint.isCommentRequired && !values.message) {
              return {
                message: '',
              };
            }

            return {};
          }}
          onSubmit={async (values, actions) => {
            try {
              await onSubmit(complaint, values.message);
            } catch (e) {
              actions.setErrors({ message: e });
            }
          }}
        >
          {props => (
            <form onSubmit={props.handleSubmit}>
              <textarea
                autoFocus
                rows={3}
                className={classNames(
                  styles['textarea'],
                  props.errors.message !== undefined && styles['textarea-error'],
                )}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.message}
                name="message"
              />
              {props.errors.message && <div className={styles['error']}>{props.errors.message}</div>}
              <Button type="submit" theme="fill_primary" size="XS">
                Отправить жалобу
              </Button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
}
